var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c(
      "div",
      { staticClass: "breadcrumb-layout" },
      [
        _c(
          "el-breadcrumb",
          { attrs: { separator: "/" } },
          [
            _c("el-breadcrumb-item", { attrs: { to: { path: "/" } } }, [
              _vm._v("首页")
            ]),
            _vm._v(" "),
            _c(
              "el-breadcrumb-item",
              { attrs: { to: { path: _vm.SwbOrienteeringCallBidListPath } } },
              [_vm._v("定向招标市场")]
            ),
            _vm._v(" "),
            _c("el-breadcrumb-item", [_vm._v("招标报名")])
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "right",
            on: {
              click: function($event) {
                _vm.goBack()
              }
            }
          },
          [_vm._m(0)]
        )
      ],
      1
    ),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "bidding-enroll" },
      [
        _c("div", { staticClass: "bidding-info" }, [
          _vm._m(1),
          _vm._v(" "),
          _c("div", { staticClass: "info" }, [
            _c("ul", { staticClass: "info-list" }, [
              _c(
                "li",
                { staticClass: "info-item", staticStyle: { width: "25%" } },
                [
                  _c("span", [_vm._v("标书名称：")]),
                  _vm._v(" "),
                  _c("a", { staticClass: "mr10" }, [
                    _vm._v(_vm._s(_vm.callBidDocInfo.title))
                  ])
                ]
              ),
              _vm._v(" "),
              _c(
                "li",
                { staticClass: "info-item", staticStyle: { width: "25%" } },
                [
                  _c("span", [_vm._v("报名截止时间：")]),
                  _vm._v(" "),
                  _c("span", [
                    _vm._v(_vm._s(_vm.callBidDocInfo.enrollCloseTime))
                  ])
                ]
              ),
              _vm._v(" "),
              _c(
                "li",
                { staticClass: "info-item", staticStyle: { width: "25%" } },
                [
                  _c("span", [_vm._v("报名费用：")]),
                  _vm._v(" "),
                  _vm.callBidDocInfo.enrollFree
                    ? _c("span", [_vm._v("免费")])
                    : _c("span", [
                        _vm._v(_vm._s(_vm.callBidDocInfo.enrollFee) + "元")
                      ])
                ]
              )
            ])
          ])
        ]),
        _vm._v(" "),
        _c(
          "el-form",
          {
            ref: "ruleForm",
            staticClass: "demo-ruleForm",
            attrs: { model: _vm.bidEnrollInfo, rules: _vm.rules }
          },
          [
            _c("div", { staticClass: "enroll-info" }, [
              _c("div", { staticClass: "content-caption dashed" }, [
                _c("span", [
                  _c("span", { staticClass: "color-laber" }),
                  _vm._v("报名信息")
                ])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "form-info" }, [
                _c("div", { staticClass: "form-row" }, [
                  _c("div", { staticClass: "form-label" }, [
                    _c("label", { staticClass: "required" }, [
                      _vm._v("联系人：")
                    ])
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "form-value width-1-5x" },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { prop: "contactName" } },
                        [
                          _c("el-input", {
                            model: {
                              value: _vm.bidEnrollInfo.contactName,
                              callback: function($$v) {
                                _vm.$set(_vm.bidEnrollInfo, "contactName", $$v)
                              },
                              expression: "bidEnrollInfo.contactName"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "form-row" }, [
                  _c("div", { staticClass: "form-label" }, [
                    _c("label", { staticClass: "required" }, [
                      _vm._v("联系电话：")
                    ])
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "form-value width-1-5x" },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { prop: "contactTel" } },
                        [
                          _c("el-input", {
                            model: {
                              value: _vm.bidEnrollInfo.contactTel,
                              callback: function($$v) {
                                _vm.$set(_vm.bidEnrollInfo, "contactTel", $$v)
                              },
                              expression: "bidEnrollInfo.contactTel"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "form-row" }, [
                  _c("div", { staticClass: "form-label" }, [
                    _c("label", [_vm._v("联系邮箱：")])
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "form-value width-1-5x" },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { prop: "contactEmail" } },
                        [
                          _c("el-input", {
                            model: {
                              value: _vm.bidEnrollInfo.contactEmail,
                              callback: function($$v) {
                                _vm.$set(_vm.bidEnrollInfo, "contactEmail", $$v)
                              },
                              expression: "bidEnrollInfo.contactEmail"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                ])
              ])
            ])
          ]
        ),
        _vm._v(" "),
        _vm._m(2),
        _vm._v(" "),
        _c("table", { staticClass: "custom-tbl" }, [
          _vm._m(3),
          _vm._v(" "),
          _c(
            "tbody",
            { staticClass: "body" },
            _vm._l(_vm.merchantQualiList, function(merchantQuali) {
              return _c("tr", { staticClass: "row" }, [
                _c("td", [_c("span", [_vm._v(_vm._s(merchantQuali.groupNo))])]),
                _vm._v(" "),
                _c(
                  "td",
                  { class: { selected: merchantQuali.qualiId != null } },
                  [
                    _c("span", [
                      _vm._v(_vm._s(merchantQuali.callQualiTypeName))
                    ])
                  ]
                ),
                _vm._v(" "),
                _c("td", [
                  _c("span", [
                    _vm._v(
                      _vm._s(
                        _vm.qualiKindList[merchantQuali.callQualiKind].text
                      )
                    )
                  ])
                ]),
                _vm._v(" "),
                _c("td", [
                  _c(
                    "div",
                    { staticClass: "table-addr" },
                    [
                      _c(
                        "el-radio-group",
                        {
                          attrs: { disabled: "" },
                          model: {
                            value: merchantQuali.callMandatory,
                            callback: function($$v) {
                              _vm.$set(merchantQuali, "callMandatory", $$v)
                            },
                            expression: "merchantQuali.callMandatory"
                          }
                        },
                        [
                          _c("el-radio", { attrs: { label: false } }, [
                            _vm._v("否")
                          ]),
                          _vm._v(" "),
                          _c("el-radio", { attrs: { label: true } }, [
                            _vm._v("是")
                          ])
                        ],
                        1
                      )
                    ],
                    1
                  )
                ]),
                _vm._v(" "),
                _c("td", [
                  _c(
                    "a",
                    {
                      staticClass: "swb-btn-link",
                      on: {
                        click: function($event) {
                          _vm.showMerchantQualiDialog(
                            merchantQuali.callQualiTypeId
                          )
                        }
                      }
                    },
                    [_vm._v("选择")]
                  )
                ])
              ])
            })
          )
        ]),
        _vm._v(" "),
        _vm._m(4),
        _vm._v(" "),
        _c("table", { staticClass: "custom-tbl" }, [
          _vm._m(5),
          _vm._v(" "),
          _c(
            "tbody",
            { staticClass: "body align-left" },
            _vm._l(_vm.callBidDocInfo.staffQualiList, function(staffQuali) {
              return _c("tr", { staticClass: "row" }, [
                _c("td", { staticClass: "align-left" }, [
                  _vm._v(_vm._s(staffQuali.name))
                ]),
                _vm._v(" "),
                _c("td", { staticClass: "align-left" }, [
                  _vm._v(_vm._s(staffQuali.qualiName))
                ]),
                _vm._v(" "),
                _c("td", [
                  _c("div", { staticClass: "table-addr" }, [
                    staffQuali.qualiLevel == 1
                      ? _c("span", [_vm._v("一级")])
                      : _vm._e(),
                    _vm._v(" "),
                    staffQuali.qualiLevel == 2
                      ? _c("span", [_vm._v("二级")])
                      : _vm._e(),
                    _vm._v(" "),
                    staffQuali.qualiLevel == 3
                      ? _c("span", [_vm._v("三级")])
                      : _vm._e(),
                    _vm._v(" "),
                    staffQuali.qualiLevel == 4
                      ? _c("span", [_vm._v("四级")])
                      : _vm._e(),
                    _vm._v(" "),
                    staffQuali.qualiLevel == 5
                      ? _c("span", [_vm._v("五级")])
                      : _vm._e()
                  ])
                ]),
                _vm._v(" "),
                _c("td", [
                  _c("div", { staticClass: "table-addr" }, [
                    staffQuali.mandatory
                      ? _c("span", [_vm._v("是")])
                      : _c("span", [_vm._v("否")])
                  ])
                ]),
                _vm._v(" "),
                _c("td", [_vm._v(_vm._s(staffQuali.quantity))]),
                _vm._v(" "),
                _c("td", [
                  staffQuali.mandatory &&
                  staffQuali.quantity > staffQuali.staffQualiQuantity
                    ? _c("span", { staticClass: "font-red" }, [
                        _vm._v(_vm._s(staffQuali.staffQualiQuantity))
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  !staffQuali.mandatory &&
                  staffQuali.quantity > staffQuali.staffQualiQuantity
                    ? _c("span", { staticClass: "font-gold" }, [
                        _vm._v(_vm._s(staffQuali.staffQualiQuantity))
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  staffQuali.quantity <= staffQuali.staffQualiQuantity
                    ? _c("span", [
                        _vm._v(_vm._s(staffQuali.staffQualiQuantity))
                      ])
                    : _vm._e()
                ])
              ])
            })
          )
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "content-caption dashed" }, [
          _vm._v("其他招标要求详见招标公告。")
        ]),
        _vm._v(" "),
        _vm._m(6),
        _vm._v(" "),
        _c("div", { staticClass: "form-single mt20" }, [
          _c(
            "div",
            {
              staticClass: "title required",
              staticStyle: { "text-align": "left" }
            },
            [_vm._v("上传附件")]
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "content", staticStyle: { "padding-left": "38px" } },
            [
              _c("swb-file-upload", {
                attrs: {
                  fileGroup: "image-goods",
                  onBeforeUpload: _vm.onBeforeUpload,
                  onProgress: _vm.onProgress,
                  onDone: _vm.onUploadDone,
                  multipleFile: true
                }
              }),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "file-area clearfix" },
                _vm._l(_vm.enrollFiles, function(enrollfile, index) {
                  return _c("swb-file-item", {
                    attrs: {
                      trackKey: index,
                      fileName: enrollfile.name,
                      fileBrowseUrl: enrollfile.fileBrowseUrl,
                      fileUuid: enrollfile.fileUuid,
                      fileDownloadUrl: enrollfile.fileDownloadUrl,
                      fileMd5: enrollfile.fileMd5,
                      deletable: true,
                      onDelete: _vm.removeUpload
                    }
                  })
                })
              )
            ],
            1
          )
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "hint block mt20 mb20" },
          [
            _c(
              "el-checkbox",
              {
                model: {
                  value: _vm.agreeFlag,
                  callback: function($$v) {
                    _vm.agreeFlag = $$v
                  },
                  expression: "agreeFlag"
                }
              },
              [
                _c("p", { staticClass: "inline-block" }, [
                  _vm._v("我司承诺所提供材料按招标公告要求提供，并且真实有效")
                ])
              ]
            )
          ],
          1
        )
      ],
      1
    ),
    _vm._v(" "),
    _vm.merchantTypeMatches
      ? _c(
          "div",
          {
            staticClass: "form-toolbar align-center mt30",
            staticStyle: { padding: "0" }
          },
          [
            _c(
              "button",
              { staticClass: "swb-btn mr20", on: { click: _vm.goBackEnroll } },
              [_vm._v("取消")]
            ),
            _vm._v(" "),
            _c(
              "button",
              {
                staticClass: "swb-btn mr20",
                on: {
                  click: function($event) {
                    _vm.saveBidEnrollInfo()
                  }
                }
              },
              [_vm._v("保存")]
            )
          ]
        )
      : _vm._e()
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("button", { staticClass: "swb-btn swb-btn-link" }, [
      _c("i", { staticClass: "icon iconfont icon-fanhui2 mr5" }),
      _vm._v("返回")
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "content-caption dashed" }, [
      _c("span", [
        _c("span", { staticClass: "color-laber" }),
        _vm._v("招标信息")
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "content-caption dashed" }, [
      _c("span", [
        _c("span", { staticClass: "color-laber" }),
        _vm._v("资质信息")
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("thead", { staticClass: "head" }, [
      _c("tr", { staticClass: "row" }, [
        _c("th", [_vm._v("招标资质组号")]),
        _vm._v(" "),
        _c("th", [_vm._v("招标资质名称")]),
        _vm._v(" "),
        _c("th", [_vm._v("招标资质类型")]),
        _vm._v(" "),
        _c("th", [_vm._v("是否必须")]),
        _vm._v(" "),
        _c("th", { attrs: { width: "180" } }, [_vm._v("操作")])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "content-caption dashed" }, [
      _c("span", [
        _c("span", { staticClass: "color-laber" }),
        _vm._v("要求的人员资质")
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("thead", { staticClass: "head align-left" }, [
      _c("tr", { staticClass: "row" }, [
        _c("th", [_vm._v("资质类型")]),
        _vm._v(" "),
        _c("th", [_vm._v("类型名称")]),
        _vm._v(" "),
        _c("th", [_vm._v("类型等级（及以上）")]),
        _vm._v(" "),
        _c("th", [_vm._v("是否必须")]),
        _vm._v(" "),
        _c("th", [_vm._v("要求数量")]),
        _vm._v(" "),
        _c("th", [_vm._v("资质数量")])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "content-caption dashed" }, [
      _c("span", [
        _c("span", { staticClass: "color-laber" }),
        _vm._v("附件信息")
      ])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-3af879cc", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3af879cc","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/compo/callbid/BidEnrollSignUp.vue
// module id = 2137
// module chunks = 1